import { PagingShowAllText } from '../../../functions/TableFunctions';

export const InitialCommonCommands = (t) => {

    PagingShowAllText(t);
    const nameFilterInput = document.getElementsByTagName('input');

    if (nameFilterInput.length > 0) {
        nameFilterInput[0].focus();
    }
};
